import { action } from 'easy-peasy';
import { setUtilizationReportFilter } from '~/services/localStorage/filters';

import { IActionSetUtilizationReportFilters } from '../types';

const setUtilizationReportFilters: IActionSetUtilizationReportFilters = action((state, payload) => {
  const updatedFilters = { ...state.utilization.filters, ...payload };
  // save filters to storage
  setUtilizationReportFilter(updatedFilters);

  state.utilization.filters = updatedFilters;
});

export default setUtilizationReportFilters;
